import React, { useState } from 'react';
import './PragueAreasCard.css';

const PragueAreasCard = ({ imageSrc, title, description }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <div 
      className="areas-card" 
      onMouseEnter={() => setHovered(true)} 
      onMouseLeave={() => setHovered(false)}
    >
      <img src={imageSrc} alt={title} className="areas-card-image" />
      <div className={`areas-card-overlay ${hovered ? 'hovered' : ''}`}>
        <div className="areas-card-title">{title}</div>
        {hovered && <div className="areas-card-description">{description}</div>}
      </div>
    </div>
  );
};

export default PragueAreasCard;
